import React from 'react'
import { usePageView } from '@fs/zion-analytics'
import { useNonReligiousMode } from '@fs/zion-permissions'
import AboutPageHead from './PageHead/AboutPageHead'
import AboutPageHeader from './AboutPageHeader'
import AboutPageFamilySearchPriceless from './AboutPageFamilySearchPriceless'
import AboutPageWhatWeDo from './AboutPageWhatWeDo'
import AboutPageCarousel from './AboutPageCarousel' // left right arrows seem wrong, mobile bad with images
import AboutPagePartners from './AboutPagePartners'
import AboutPageGetConnected from './AboutPageGetConnected'

const AboutPage = () => {
  usePageView({ page_detail: 'About (React)' })
  const [nonReligiousModeCheck, status, error] = useNonReligiousMode()
  const nonReligiousMode = status === 'loading' || error !== null || nonReligiousModeCheck

  return (
    <>
      <AboutPageHead />
      <AboutPageHeader />
      <AboutPageFamilySearchPriceless nonReligiousMode={nonReligiousMode} />
      <AboutPageWhatWeDo />
      {!nonReligiousMode && <AboutPageCarousel />}
      <AboutPagePartners />
      <AboutPageGetConnected nonReligiousMode={nonReligiousMode} />
    </>
  )
}

export default AboutPage
